import { wordCharacters } from "../fuxi/word-characters.js";
import { readWord, writeSyllable, writeBopomofoWord } from "@kensio/pinyinjs";

/** Add the sentence's readings and size its tiles by the total character count. */
export function prepareTiles(block: HTMLElement): void {
  for (const card of block.querySelectorAll<HTMLElement>(
    "[data-cb-fuxi-tiles]",
  )) {
    const tiles = [
      ...card.querySelectorAll<HTMLElement>("[data-cb-fuxi-tile]"),
    ];
    const length = tiles.reduce(
      (total, tile) =>
        total +
        wordCharacters(tile.querySelector("[lang]")?.textContent ?? "").length,
      0,
    );
    card.style.setProperty(
      "--cb-yufa-tile-size",
      `${String(Math.max(1.15, Math.min(1.8, 2.25 - length * 0.045)))}rem`,
    );
    for (const tile of tiles) {
      const reading = readWord(tile.dataset["cbYufaReading"] ?? "");
      if (reading === undefined || reading.length === 0) {
        continue;
      }
      const pinyin = document.createElement("span");
      pinyin.className = "lianxi-yufa-tile-reading pinyin";
      pinyin.lang = "zh-Latn-CN-pinyin";
      for (const syllable of reading) {
        const ink = document.createElement("span");
        ink.className = `py-tone-${String(syllable.tone ?? 5)}`;
        ink.textContent = writeSyllable(syllable);
        pinyin.append(ink);
      }
      const zhuyin = document.createElement("span");
      zhuyin.className = "lianxi-yufa-tile-reading zhuyin";
      zhuyin.lang = "zh-Bopo";
      zhuyin.textContent = writeBopomofoWord(reading);
      tile.append(pinyin, zhuyin);
    }
  }
}
